// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outfunnel-logo[data-v-295b5577]{width:6rem;height:6rem}.divider .label[data-v-295b5577]{background:#fff}.divider .line[data-v-295b5577]{border-bottom:1px solid #616161;width:100%;margin-bottom:-0.8rem}", ""]);
// Exports
module.exports = exports;
